<template>
  <DxScrollView
    id="fieldReportScrollView"
    ref="scrollView"
    :elementAttr="scrollListAttributes"
    :use-native="true"
    @reach-bottom="reachBottom"
    @scroll="scrollTest"
    @pull-down="pullDown"
  >
    <div class="field_report_list_holder">
      <div v-for="(field_report_data, r_idx) in field_report_list_data" :key="r_idx">
        <div class="field_report_item">
          <div class="field_report_main_icon">
            <div class="field_report_main_icon_file">
              <img src="@/assets/images/icons/parcel.svg" />
            </div>
          </div>
          <div class="field_report_main_info" @click="reportClickOnSelectionMode(field_report_data, r_idx)">
            <div style="display: flex; align-items: center; gap: 8px">
              <div
                class="field_report_status"
                :style="{
                  backgroundColor: !field_report_data.deleted_at ? (field_report_data.finished_weighing == 0 ? '#FFA500' : '#008000') : '#FF0000',
                  color: '#fff',
                  padding: '2px 4px',
                  borderRadius: '4px',
                  display: 'inline-block',
                  margin: '4px 0',
                  //whiteSpace: 'nowrap',
                }"
              >
                {{ !field_report_data.deleted_at ? (field_report_data.finished_weighing == 0 ? "în curs" : "finalizat") : "șters" }}
              </div>
              <div class="product_name">
                {{
                  field_report_data.weighing_products?.product_code
                    ? `${field_report_data.weighing_products?.product_name} (${field_report_data.weighing_products?.product_code})`
                    : field_report_data.weighing_products?.product_name || "-"
                }}
              </div>
            </div>
            <div class="product_type">{{ field_report_data.field_delivery_note_document ? field_report_data.field_delivery_note_document : "-" }}</div>
            <div class="product_type">
              {{ "Nr. de înmat. al utilajului de tractare: " }}
              {{ field_report_data?.document_data?.tractor_number_plate ? field_report_data.document_data.tractor_number_plate : "-" }}
            </div>
            <div class="product_type" v-if="!hasEstimatedWeight">
              {{ "Tara: " }}
              {{ field_report_data?.empty_weight_kg ? parseFloat(field_report_data.empty_weight_kg) + " kg" : "-" }}
            </div>
          </div>
          <div class="field_report_quantity">{{ getFormattedStockQuantity(field_report_data) }} {{ "kg" }}</div>
          <div class="expand_icon_holder">
            <div :class="field_report_data.expanded ? 'expand_icon_expanded' : 'expand_icon'" @click="expandStoc(field_report_data, r_idx)">
              <img v-show="field_report_data.expanded" src="@/assets/images/icons/arrow_up_green.svg" />
              <img v-show="!field_report_data.expanded" src="@/assets/images/icons/arrow_down.svg" />
            </div>
          </div>
        </div>
        <FieldReportDetails
          :fieldReportData="field_report_data"
          v-show="field_report_data.expanded"
          :selectionMode="selectionMode"
          @warehouseClickOnSelectionMode="warehouseClickOnSelectionMode"
        ></FieldReportDetails>
      </div>
      <div style="height: 40px"></div>
      <toast-message ref="toastMessage"></toast-message>
    </div>
  </DxScrollView>
</template>

<script>
import { mapActions } from "vuex";
import Vue from "vue";
import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);
import FieldReportDetails from "./fieldReportDetails.vue";
import { DxScrollView } from "devextreme-vue/scroll-view";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
import { getFormattedQuantity } from "~/helpers/stockHelper";

export default {
  name: "FieldReportList",
  props: {
    fillAtMount: {
      type: Boolean,
      default: true,
    },
    filterData: {
      type: Object,
      default: null,
    },
    selectionMode: {
      type: Boolean,
      default: false,
    },
    reportSelectMode: {
      type: Boolean,
      default: false,
    },
    hasEstimatedWeight: {
      type: Number,
      default: 1,
    },
    isDeleted: {
      type: Number,
      default: null,
    },
    userFilter: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      noFieldReportData: false,
      scrollListAttributes: {
        class: "field_report_list_scroller",
      },
      executeFillFieldReport: true,
      pagination: {},
      scrollOffset_top: 0,
      field_report_list_data: [],
      historyTemplateData: {
        product: {},
        warehouse: {},
      },
    };
  },
  watch: {
    scrollOffset_top: {
      handler: function (newVal, oldVal) {
        if (newVal < oldVal) {
          this.$emit("scrollDown");
        }
        if (newVal > oldVal) {
          this.$emit("scrollUp");
        }
      },
    },
    filterData: {
      handler: function (newVal, oldVal) {
        if (newVal != null) {
          this.fillFieldReport(1, newVal, this.fillCallback);
        }
      },
      deep: true,
    },
  },
  components: {
    FieldReportDetails,
    DxScrollView,
    ToastMessage,
  },
  methods: {
    ...mapActions({
      getWeighingOnScale: "scale/getWeighingOnScale",
    }),
    onScroll() {},
    expandStoc(field_report_data, idx) {
      field_report_data.expanded = !field_report_data.expanded;
      this.$set(this.field_report_list_data, idx, field_report_data);
    },
    reachBottom() {
      if (this.pagination.current_page < this.pagination.last_page) {
        this.fillFieldReport(this.pagination.current_page + 1, this.filterData, this.fillCallback);
      }
    },
    scroll(event) {
      this.scrollOffset_top = event.scrollOffset.top;
    },
    pullDown(event) {
      event.component.release();
    },
    scrollTest() {},
    fillFieldReport(page_number, filter = null, callback = null) {
      let limit = (this.$refs["scrollView"].instance._$element[0].clientHeight / 75 + 1).toFixed(0);

      if (this.executeFillFieldReport) {
        filter = filter ?? {};
        filter.page = page_number;
        filter.limit = limit;
        filter.field_report = 1;
        filter.user_filter = this.userFilter;
        filter.has_estimated_weight = this.hasEstimatedWeight;
        filter.deleted_at = this.isDeleted;

        if (page_number == 1) {
          this.$refs["scrollView"].instance.release(false);
        }

        this.getWeighingOnScale(filter).then((response) => {
          if (page_number == 1) {
            this.field_report_list_data = [];
            this.$set(this.field_report_list_data, []);
          }
          response.data.data.forEach((fieldReport) => {
            fieldReport.selected = false;
            fieldReport.expanded = false;
            if (this.field_report_list_data.find((obj) => obj.uuid == fieldReport.uuid) === undefined) {
              this.field_report_list_data.push(fieldReport);
              this.$set(this.field_report_list_data, this.field_report_list_data.length - 1, fieldReport);
            }
          });

          this.pagination = response.data.pagination;
          this.noFieldReportData = this.field_report_list_data.length == 0;
          if (callback != null) {
            callback();
          }
        });
      }
      this.$set(this, "executeFillFieldReport", true);
    },
    fillCallback() {
      if (this.pagination) {
        if (this.pagination.current_page == this.pagination.last_page || this.field_report_list_data.length == 0) {
          this.$refs["scrollView"].instance.release(true);
        } else {
          this.$refs["scrollView"].instance.release(false);
        }
        this.$refs["scrollView"].instance.update();
        if (this.pagination.current_page == 1) {
          this.$refs["scrollView"].instance.scrollTo(0);
        }
      }
    },
    reloadList() {
      this.fillFieldReport(1, this.filterData, this.fillCallback);
    },
    reportClickOnSelectionMode(field_report_data, idx) {
      if (this.reportSelectMode) {
        this.$emit("reportSelected", field_report_data);
        return;
      }

      if (this.selectionMode) {
        if (field_report_data.field_report_list && field_report_data.field_report_list.length == 0) {
          this.$refs.toastMessage.showInfo("Produsul nu există in stoc!");
        }
        if (field_report_data.field_report_list && field_report_data.field_report_list.length == 1) {
          this.$emit("productSelected", field_report_data, field_report_data.field_report_list[0]);
        }
        if (field_report_data.field_report_list && field_report_data.field_report_list.length > 1) {
          field_report_data.expanded = true;
          this.$set(this.field_report_list_data, idx, field_report_data);
        }
      }
    },
    warehouseClickOnSelectionMode(field_report_data, warehouse) {
      if (warehouse.quantity > 0) {
        this.$emit("productSelected", field_report_data, warehouse);
      } else {
        this.$refs.toastMessage.showInfo("Produsul nu există in stoc!");
      }
    },
    getFormattedStockQuantity(field_report_data) {
      if (field_report_data.estimated_weight_kg > 0) {
        return getFormattedQuantity(field_report_data.estimated_weight_kg);
      }

      return 0;
    },
  },
  mounted() {
    if (this.fillAtMount) {
      this.fillFieldReport(1, this.filterData, this.fillCallback);
    }
  },
};
</script>

<style scoped>
.field_report_status {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  margin-top: 4px;
}

.field_report_item {
  padding-left: 0px !important;
}

.field_report_item .field_report_main_icon {
  padding-right: 0px !important;
}
</style>
